<template>
  <div class="generate-btn-box" :class="{ 'generate-btn-box-mobile': creatorStudio.isMobile }">
    <div
        class="generate-btn"
        v-bind:class="{ glow: this.btnActive === true && complete !== true, disabled: (loading === true || this.btnActive === false) }"
        @click="start"
    >
      <i v-if="!loading" class="far fa-wand font-size-150"></i>
      <i v-if="loading" class="fa fa-spin btn-loading-animation"></i>
      {{ 'Generate' | trans }}

      <div class="credit-cost-badge" v-if="projectName === 'Img2Go'">
        <span class="font-weight-bold">{{ totalCost }}</span>
        <CoinSVG/>
      </div>
      <div class="credit-cost-badge" v-if="projectName !== 'Img2Go'">
          <span class="font-weight-bold d-flex align-items-center credit-cost-indicator">
              <span class="d-flex align-items-center gap-5">
                 8  <CoinSVG/>
              </span>
             /
              <span class="d-flex align-items-center gap-5">
              10s <i class="far font-weight-bold fa-clock"></i>
              </span>
            </span>
      </div>

    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import user from './../../mixins/user.mixin';
import CreditManager from '../../manager/CreditManager';
import {EVENT_JOB_START} from '../../events/job.events';
import {EventBus} from '../../events/event.bus';
import currentJob from './../../mixins/current_job.mixin';
import CoinSVG from './../../../form/icons/CoinSVG.vue';
import Analytics from "../../util/Analytics";

export default {
  name: 'GenerateBtn',
  props: {},
  components: {CoinSVG},
  mixins: [store, currentJob, user],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    start() {
      if (this.btnActive === true) {
        Analytics.send('creator_studio_action', `generate_btn`, this.currentJob);

        EventBus.$emit(EVENT_JOB_START, {id: this.id});
      }
    },
  },
  computed: {
    totalCost() {
      return CreditManager.totalCost();
    },
    btnActive() {
      if (this.creatorStudio.settings.activeTool === 'texttoimage') {
        if (this.loading === false && this.creatorStudio.settings.prompt !== '') {
          return true;
        }
      }

      if (this.creatorStudio.settings.activeTool === 'similiarimage') {
        if (this.loading === false && this.creatorStudio.settings.similiarImageJob.base64 !== null) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>
<style lang="scss">
.gap-5 {
  gap:3px;
}
.credit-cost-indicator {
  gap: 3px;
}
.generate-btn-box-mobile {
  border-top: 1px solid #595959;
  background: #272727;
  padding: 10px 20px !important;

  .generate-btn {
    height: 55px;
  }
}

.generate-btn-box {
  padding: 20px;
  position: relative;

  .credit-cost-badge {
    position: absolute;
    right: 35px;
  }
}

.generate-btn {
  background: #1266f1;
  color: white;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 17.5px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #1161e5;
  }
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
